import ProductFeatures from "../Common/ProductFeaturesPrev";
import SiteTypeOptions from "../Common/SiteTypeOptionsPrev";
import UpcList from "../Common/UpcList";
import { PRICE_LIST, PriceListType } from "src/config/priceTypeList";
import { getProductInfo } from "src/utils/storage/product";
import { useState } from "react";
import { useRouter } from "src/hooks/useRouter";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface IRightDetailBoxProps {
  licenseCount?: number;
  externalLicenseCount?: number;
  toggleAskPromotionOn: boolean;
  startDate?: string;
  endDate?: string;
  isRenew?: boolean;
  isCheckPromotionCode?: string;
  isCheckAskPromotion?: boolean;
  setValue?: UseFormSetValue<any>;
  // promotionAsk?: () => void;
  promotionApply?: () => void;
}
const RightDetailBox = ({
  licenseCount,
  externalLicenseCount,
  toggleAskPromotionOn,
  startDate,
  endDate,
  isRenew = false,
  setValue,
  isCheckPromotionCode,
  isCheckAskPromotion,
}: IRightDetailBoxProps) => {
  const { t } = useTranslation();
  const productInfo =
    PRICE_LIST({ t })[getProductInfo().key].filter(
      (item: PriceListType) => item.key === "premium"
    ).length > 0
      ? PRICE_LIST({ t })[getProductInfo().key].filter(
          (item: PriceListType) => item.key === "premium"
        )[0]
      : { key: "", name: "", featuresCnt: 0, upcCnt: -1 };
  // console.log("productInfo", productInfo);
  const productKey = getProductInfo().key;
  const [selectAppList, setSelectAppList] = useState<string[]>([]);
  const { goSitePromotion } = useRouter();
  const { isOciProduct } = useIsOciProduct();
  // const { watch } = useFormContext();

  // const { register } = useForm();
  return (
    <div className="flex-item box box__rt bg-white">
      {/* <form className="form"> */}
      <SiteTypeOptions
        productKey={productKey}
        // handleChange={handleChange}
        isRenew={isRenew}
      />
      <ProductFeatures productKey={productKey} productInfo={productInfo} />

      {toggleAskPromotionOn ? (
        <div>
          <hr />
          <div className="flex align-center">
            <div className="width w-30p">
              <span className="form-item-title">
                {t("siteType.premium.detail.plan.user")}
              </span>
            </div>
            <div className="width w-70p text right">
              <span className="form-item-title">
                <b className="text text--black">{licenseCount}</b>
              </span>
            </div>
          </div>
          {window.sessionStorage.getItem("product") === "WRAPSODY_ECO" && (
            <div className="flex align-center">
              <div className="width w-70p">
                <span className="form-item-title">
                  {t("siteType.premium.detail.plan.userExtenalInvite")}
                </span>
              </div>
              <div className="width w-30p text right">
                <span className="form-item-title">
                  <b className="text text--black">
                    {externalLicenseCount ?? 0}
                  </b>
                </span>
              </div>
            </div>
          )}
          <div className="flex align-center">
            <div className="width w-30p">
              <span className="form-item-title">
                {t("siteType.premium.detail.plan.period")}
              </span>
            </div>
            <div className="width w-70p text right">
              <span className="form-item-title">
                {t("siteType.premium.detail.plan.startDate")}
                <b className="text text--black mg ml-10">{startDate}</b>
              </span>
            </div>
          </div>
          <div className="flex align-center">
            <div className="width w-30p"></div>
            <div className="width w-70p text right">
              <span className="form-item-title">
                {t("siteType.premium.detail.plan.endDate")}
                <b className="text text--black mg ml-10">{endDate}</b>
              </span>
            </div>
          </div>
          {/* 사용자당 스토리지 용량 */}
          {/* <div className="flex align-center">
            <div className="width w-70p">
              <span className="form-item-title">
                {t("siteType.premium.detail.plan.userStorage")}
              </span>
            </div>
            <div className="width w-30p text right">
              <span className="form-item-title">
                <b className="text text--black">{userPerStorage}GB</b>
              </span>
            </div>
          </div> */}

          <hr />
          {!["DSPM", "DSP", "FIRESIDE"].includes(
            getProductFromSessionStorage()
          ) && (
            <UpcList
              productInfo={productInfo}
              setValue={setValue}
              // selectAppList={selectAppList}
              // setSelectAppList={setSelectAppList}
              // register={register}
              // applicationList={applicationList}
              // selectAppList={selectAppList}
              // handleChange={handleChange}
              // openExtDetailModal={openExtDetailModal}
            />
          )}
          <button
            type="submit"
            disabled={!isCheckAskPromotion}
            // onClick={(e) => {
            // }}
            className="btn btn-green width w-100p mg mt-20 pd py-10"
          >
            {t("siteType.send")}
          </button>
        </div>
      ) : (
        <div>
          {/* <hr /> */}
          {/* <UpcList productInfo={productInfo} setValue={setValue} /> */}
          <button
            type="submit"
            disabled={
              isCheckPromotionCode !== "OK"
              // && nxacAppUids.length === 0
            }
            // onClick={promotionApply}
            // onClick={() => console.log("버튼 클릭!")}
            className="btn btn-green width w-100p mg mt-20 pd py-10"
          >
            {t("siteType.subscribeBtn")}
          </button>
        </div>
      )}

      {/* 추천인 */}
      {/* {toggleAskPromotionOn && (
        <div>
          <hr />
          <span className="form-item-title">
            {t("siteType.referralIdOptional")}
          </span>
          <div>
            <input
              id="referralId"
              {...register("referralId")}
              // name="referralId"
              // value={referralId}
              // onChange={handleChange}
              className="form-control custom-form width w-370"
              placeholder={t("siteType.enterIdEmail")}
            />
          </div>
        </div>
      )} */}
      {/* </form> */}
    </div>
  );
};

export default RightDetailBox;
